import { render } from "./ConfirmationSubmissionModal.vue?vue&type=template&id=83391056&scoped=true"
import script from "./ConfirmationSubmissionModal.vue?vue&type=script&lang=js"
export * from "./ConfirmationSubmissionModal.vue?vue&type=script&lang=js"

import "@/Common/Styles/previewModal.scss?vue&type=style&index=0&id=83391056&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83391056"]])

export default __exports__